import React, { useState, useContext } from "react";
import { AppContext } from "../../App";
import {
    Collapse,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Nav,
    NavItem,
    NavLink,
    Navbar,
    NavbarText,
    NavbarToggler,
    UncontrolledDropdown,
} from "reactstrap";

import "bootstrap/dist/css/bootstrap.min.css";

const TopMenu = () => {
    const [appData, setAppData] = useContext(AppContext);
    const [isOpen, setIsOpen] = useState(true);

    return (
        <Navbar color="dark" container="md" dark expand="md">
            <NavbarToggler onClick={() => setIsOpen(!isOpen)} />
            <Collapse isOpen={isOpen} navbar>
                <Nav className="me-auto" navbar>
                    <NavItem>
                        <NavLink href="/">Start</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="/DataSets/">Zestawy danych</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="/Statistics/">Statystyki</NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink href="/Status/">Status</NavLink>
                    </NavItem>

                    {
                        appData.roles.includes('Superadmin') &&
                        (
                            <NavItem>
                                <NavLink href="/Users/">Użytkownicy</NavLink>
                            </NavItem>
                        )
                    }

                </Nav>
            </Collapse>
        </Navbar>
    );
};

export default TopMenu;
